import styled from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

export const Label = styled.span`
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._500};
  margin-right: 3px;
`;

export const Text = styled.span`
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._500};
  margin-right: 3px;
`;

export const CopyIconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  svg {
    fill: ${() => Palette.PrimaryGray._400};
  }
`;

export const CopiedMessage = styled.p`
  pointer-events: none;
  z-index: 5000;
  background: ${Palette.PrimaryGray._000};
  color: #000;
  font-size: 12px;
  line-height: 14px;
  padding: 3px 8px;
  border-radius: 6px;
  border: 1px solid ${Palette.PrimaryGray._200};
  box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
  ::before {
    position: absolute;
    content: '';
    width: 9px;
    height: 9px;
    border-right: 1px solid ${Palette.PrimaryGray._200};
    border-bottom: 1px solid ${Palette.PrimaryGray._200};
    box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
    background: ${Palette.PrimaryGray._000};
    transform: rotate(45deg);
    left: 15px;
    top: 16px;
    z-index: 3000;
  }
`;

export const IconContainer = styled.div`
  display: flex;
`;

export const ParentContainer = styled.div`
  position: fixed;
  z-index: 800000;
`;
